module.exports = __webpack_public_path__ + "static/media/uk.eab16f10.png";